import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth, isAdmin } from "../context/AuthContext";
import { Button } from "./ui/button";
import { Pencil } from "lucide-react";
import AdminPurgeButton from "./AdminPurgeButton";
import AdminQuickEditDialog from "./AdminQuickEditDialog";

const QUICK_EDIT_TYPES = new Set(["gate_pass", "stack", "production_yield"]);

/**
 * Admin-only row actions: edit (link, callback, or quick-edit dialog) + permanent delete.
 */
export default function AdminEntityActions({
  entityType,
  entityId,
  entityLabel,
  onDeleted,
  editTo,
  onEdit,
  testId,
}) {
  const { user } = useAuth();
  const [editOpen, setEditOpen] = useState(false);

  if (!isAdmin(user) || entityId == null || entityId === "") {
    return null;
  }

  const useQuickEdit = QUICK_EDIT_TYPES.has(entityType) && !editTo && !onEdit;

  return (
    <div className="inline-flex items-center gap-0.5" data-testid={testId || `admin-actions-${entityType}-${entityId}`}>
      {editTo ? (
        <Button
          size="sm"
          variant="ghost"
          className="text-primary shrink-0 h-8 w-8 p-0"
          asChild
          title="Edit (admin)"
        >
          <Link to={editTo} aria-label="Edit">
            <Pencil className="h-3.5 w-3.5" />
          </Link>
        </Button>
      ) : null}
      {onEdit ? (
        <Button
          type="button"
          size="sm"
          variant="ghost"
          className="text-primary shrink-0 h-8 w-8 p-0"
          onClick={onEdit}
          title="Edit (admin)"
          aria-label="Edit"
        >
          <Pencil className="h-3.5 w-3.5" />
        </Button>
      ) : null}
      {useQuickEdit ? (
        <>
          <Button
            type="button"
            size="sm"
            variant="ghost"
            className="text-primary shrink-0 h-8 w-8 p-0"
            onClick={() => setEditOpen(true)}
            title="Edit (admin)"
            aria-label="Edit"
          >
            <Pencil className="h-3.5 w-3.5" />
          </Button>
          <AdminQuickEditDialog
            entityType={entityType}
            entityId={entityId}
            entityLabel={entityLabel}
            open={editOpen}
            onOpenChange={setEditOpen}
            onSaved={onDeleted}
          />
        </>
      ) : null}
      <AdminPurgeButton
        entityType={entityType}
        entityId={entityId}
        entityLabel={entityLabel}
        onDeleted={onDeleted}
      />
    </div>
  );
}
